import { defineComponent as _defineComponent } from 'vue'
import { myGiftOrderList } from "@/api/php/me";
import Platform from "@/config/platform";
import IMUtils from "@/network/socket/imUtils";
import { cheackQuery, ToBack } from "@/uitls/native";
import { Toast } from "vant";
import { ref, onMounted } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useI18n } from 'vue-i18n'

export default /*#__PURE__*/_defineComponent({
  name: 'IntegralMyStore',
  setup(__props, { expose }) {
  expose();

const { t } = useI18n()
const router = useRouter();
const route = useRoute();
const page = ref(0);
const listData = ref([]);
onMounted(() => {
    cheackQuery(route)
})
const getData = async (onRefresh = false) => {
    const res: any = await myGiftOrderList({
        page: page.value, limit: 10
    })
    console.log(res);

    if (res && res.code == 200) {
        if (onRefresh) {
            listData.value = res.data.list;
        } else {
            listData.value = [...listData.value, ...res.data.list]
        }
        if (res.data.list.length < 10) {
            finished.value = true;
        }

    } else {
        Toast.fail(res.msg)
    }
    loading.value = false;

}
const loading = ref(false);
const onRefresh = () => {
    page.value = 1;
    finished.value = false;
    getData(true)

};
const finished = ref(false);
const onLoad = () => {
    page.value++;
    getData()
};
// activityDetail
const toDetail = (id) => {
    console.log(id);

    // router.push(`/activityDetail?id=${id}`)
}

const toServer = () => {
    let chatkey;
    chatkey = IMUtils.createChatKey(Platform.serverId)
    router.push(`/chat/?id=${chatkey}`)
}
const addAddress = (data) => {
    router.push(`/integralAddress?id=${data.id}&&num=${data.num}`)
}


const __returned__ = { t, router, route, page, listData, getData, loading, onRefresh, finished, onLoad, toDetail, toServer, addAddress, ToBack }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})